import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles( theme => ({
    formBox: {
        border: "2px solid black",
        borderRadius: 10,
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(2),
        padding: theme.spacing(3),
        wordWrap: "break-word",
        width: "100%"
    },

    standOutText: {
        fontSize: "1.25rem",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontWeight: 500,
        lineHeight: 1.6,
        letterSpacing: "0.0075em"
    },

    uploadFileName: {
        marginBottom: "2rem",
        [theme.breakpoints.down("sm")]: {
            marginBottom: 0,
        },
    },

    dateFileName: {
        paddingLeft: "2rem",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: 0,
            paddingBottom: "1.5rem",
        },
    }
}));

export default useStyles;